// Authentication utility functions

export const isLoggedIn = () => {
  return localStorage.getItem('isLoggedIn') === 'true' && localStorage.getItem('authToken');
};

export const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

export const getUserInfo = () => {
  const userInfo = localStorage.getItem('userInfo');
  return userInfo ? JSON.parse(userInfo) : null;
};

export const logout = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('userInfo');
  localStorage.removeItem('isLoggedIn');
  localStorage.removeItem('loginTimestamp'); // 로그인 타임스탬프 제거
  
  // Also clear memorial plaza authentication
  localStorage.removeItem('isAuthenticated');
  localStorage.removeItem('authenticatedCustomerName');
  localStorage.removeItem('authenticatedCustomerBirthday');
  localStorage.removeItem('authenticationTimestamp');
  
  // Clear modal authentication (global)
  localStorage.removeItem('modalAuthenticated');
  localStorage.removeItem('modalAuthenticationTimestamp');
  
  // Clear all per-deceased-person modal authentication data
  clearAllModalAuthentications();
  
  // Force clear any form data that might be cached
  if (typeof window !== 'undefined') {
    const inputs = document.querySelectorAll('input[type="text"], input[type="password"]');
    inputs.forEach(input => {
      input.value = '';
    });
  }
  
  window.location.href = '/login';
};

// Import the function from authUtils to avoid circular dependency
// This function will be defined in authUtils.js
const clearAllModalAuthentications = () => {
  // Get all localStorage keys
  const keys = Object.keys(localStorage);
  
  // Find and remove all modal authentication keys for deceased persons
  keys.forEach(key => {
    if (key.startsWith('modalAuthenticated_') || 
        key.startsWith('authenticatedCustomerName_') || 
        key.startsWith('authenticatedCustomerBirthday_') || 
        key.startsWith('modalAuthenticationTimestamp_')) {
      localStorage.removeItem(key);
    }
  });
  
  // Also clear the current authenticated goinId reference
  localStorage.removeItem('currentAuthenticatedGoinId');
};

// export const setAuthData = (token, userInfo = {}) => {
//   localStorage.setItem('authToken', token);
//   localStorage.setItem('userInfo', JSON.stringify(userInfo));
//   localStorage.setItem('isLoggedIn', 'true');
// }; 

export const setAuthData = (token, userInfo = {}, role = "") => {
  localStorage.setItem("authToken", token);
  localStorage.setItem("userInfo", JSON.stringify({ ...userInfo, role }));
  localStorage.setItem("isLoggedIn", "true");
  // 로그인 타임스탬프 저장 (30분 자동 로그아웃용)
  localStorage.setItem("loginTimestamp", Date.now().toString());
};

export const getUserRole = () => {
  const userInfo = getUserInfo();
  return userInfo?.role || "";
};

// 30분 자동 로그아웃 체크 함수
export const checkAutoLogout = () => {
  const loginTimestamp = localStorage.getItem("loginTimestamp");
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  
  if (!isLoggedIn || !loginTimestamp) {
    return false; // 로그인하지 않았거나 타임스탬프가 없으면 체크하지 않음
  }
  
  const currentTime = Date.now();
  const loginTime = parseInt(loginTimestamp, 10);
  const elapsedTime = currentTime - loginTime;
  const thirtyMinutesInMs = 30 * 60 * 1000; // 30분을 밀리초로 변환
  
  // 30분이 지났으면 자동 로그아웃
  if (elapsedTime >= thirtyMinutesInMs) {
    logout();
    return true;
  }
  
  return false;
};

